<template>
<div class="container">
  <div class="center">
    <div class="nav-bar">
      <p>
        <span class="parent-link" @click="navToHome()">Admin</span>
        <span> >>> </span>
        <span @click="navToList()"> {{title}} </span>
        <span> >>> </span>
        <span>{{addBtnTitle}}</span> </p>
    </div>

    <div class="content">

      <div v-if="('EasyPatchLogin'==permission) || ('EasyUpdateLogin'==permission)">
        <p class="text">Enter username(email)</p>
        <div class="email">
          <input type="text" v-model="account"/>
        </div>
        <p class="text">Enter remark</p>
        <div class="email">
          <input type="text" v-model="remake"/>
        </div>
        <div class="check" v-for="(item, index) in checkInfo2">
          <input type="checkbox" v-model="item.check"/>
          <span>{{item.text}}</span>
          <div style="clear: both"></div>
        </div>
      </div>

      <div v-else-if="('FirmwareUpdateConfig'==permission)">
        <p class="text">SN </p>
        <div class="email">
          <input type="text" v-model="deviceSN"/>
        </div>

        <p class="text">version (eg. 1.36.140)</p>
        <div class="email">
          <input type="text" v-model="version"/>
        </div>

        <p class="text">model (eg. 0x7e)</p>
        <div class="email">
          <input type="text" v-model="deviceId"/>
        </div>

        <div class="check" v-for="(item, index) in checkInfo2">
          <input type="checkbox" v-model="item.check"/>
          <span>{{item.text}}</span>
          <div style="clear: both"></div>
        </div>
      </div>

      <div v-else-if="('HCLConfig'==permission)">
        <p class="text">SN </p>
        <div class="email">
          <input type="text" v-model="account"/>
        </div>

        <p class="text">Remark</p>
        <div class="email">
          <input type="text" v-model="remark"/>
        </div>
      </div>
      <div  v-else-if="('HCLConfigForEasyPatch'==permission)">
        <p class="text">Enter username(email)</p>
        <div class="email">
          <input type="text" v-model="account"/>
        </div>
      </div>
      <div class="add-btn" @click="addAccount">
        <p>{{addBtnTitle}}</p>
      </div>

<!--      <div class="check">-->
<!--        <input type="checkbox" />-->
<!--        <span>EasyPatch Login Account manaement</span>-->
<!--      </div>-->


    </div>
  </div>
</div> <!--container结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    data() {
      return {
        // 'noData':true,
        account:'',
        remake:'',
        deviceSN:'',
        remark:'',
        version:'',
        deviceId:'',
        addBtnTitle:'Add',
        checkInfo:[
          {
            check:false,
            text:'EasyPatch Login Account management',
            permission:'EasyPatchLogin'
          },
          {
            check:false,
            text:'HCP Account management',
            permission:'HCPCreate'
          },
          {
            check:false,
            text:'Software upgrade product SN management',
            permission:'FirmwareUpdateConfig'
          },
          {
            check:false,
            text:'HCL Function management -PDM',
            permission:'HCLConfig'
          },
          {
            check:false,
            text:'HCL Function management -EasyPatch',
            permission:'HCLConfigForEasyPatch'
          },
          {
            check:false,
            text:'EasyUpdate account management',
            permission:'EasyUpdateLogin'
          },
           {
            check:false,
            text:'Accounts',
            permission:'Accounts'
          },

        ],
        checkInfo2:[],
        permission:'',
        title:''
      }
    },
    computed:{

    },
    watch:{

    },
    mounted(){
      let permission = sessionStorage.getItem('account_admin_permission_value')
      let title = sessionStorage.getItem('account_admin_permission_title')
      this.permission = permission;
      this.title = title;
    },
    methods: {
      addPatchAccount(){
        this.$http.post('/api/v2.1/account_manage/add', {
          data:[
            {
              account:this.account,
               param: {
                remark:this.remake
              }
            }
          ],
          role:this.permission,
          permission:this.permission
        }).then(function (res) {
          let error=res.body.error;
          if (error) {
            if (2==error) {
              this.$message.error('Account is not found.')
            } else {
              this.$message.error('code:'+error)
            }
          } else {
            let result = res.body.result;
            if (result) {
              let resError=result[0].error
              if (resError) {
                if (2==resError) {
                  this.$message.error('Account is not found.')
                } else {
                  this.$message.error('code:'+resError)
                }
                //this.$message.error('code:'+resError)
                return;
              }
            }

            this.$message({
              type:'success',
              message:'Account created successfully.'
            })
            this.$router.push('/accountsadmin_list')
          }
        }, function (err) {

        })
      },

      addFirmwareUpdateConfig(){
        this.$http.post('/api/v2.1/account_manage/add', {
          data:[
            {
              deviceSN:this.deviceSN,
              deviceId:this.deviceId,
              version:this.version
            }
          ],
          role:this.permission,
          permission:this.permission
        }).then(function (res) {
          let error=res.body.error;

          if (error) {
            this.$message.error('code:'+error)
          } else {
            this.$message({
              type:'success',
              message:'Success'
            })
            this.$router.push('/accountsadmin_list')
          }
        }, function (err) {

        })
      },

      checkSNFormat(sn) {
        let flag=false;

        if (/^[\d]{9}$/.test(sn) ) {
          let value=parseInt(sn);
          if (100000000<= value && value <= 109999999) {
            flag=true;
          }
        } else if (/^[\da-fA-F]{8}$/.test(sn)) {
          flag=true;
        }
        return flag;
      },

      addAccount() {
        // let permission=[];
        //
        // for (let i=0; i<this.checkInfo.length; i++) {
        //   if (this.checkInfo[i].check) {
        //     permission.push(this.checkInfo[i].permission)
        //   }
        // }


        if ('EasyPatchLogin'==this.permission || 'EasyUpdateLogin'==this.permission
          || 'HCLConfig'==this.permission||'HCLConfigForEasyPatch'==this.permission
        ) {
          if (!this.account) {
            this.$message({
              type:'warning',
              message:'empty'
            })
            return;
          }
          if ('HCLConfig'==this.permission) {
            if (!this.checkSNFormat(this.account)) {
              this.$message({
                type:'warning',
                message:'SN error'
              })
              return;
            } else {
              this.account = this.account
            }
          }
          if('HCLConfigForEasyPatch'==this.permission) {
            this.account = this.account
          }

          //
          this.addPatchAccount()
        } else if ('FirmwareUpdateConfig'==this.permission) {
          if (!this.deviceSN || !this.deviceId || !this.version) {
            this.$message({
              type:'warning',
              message:'empty'
            })
            return;
          }

          if (!this.checkSNFormat(this.deviceSN)) {
            this.$message({
              type:'warning',
              message:'SN error'
            })
            return;
          } else {
            this.deviceSN = this.deviceSN
          }


          this.addFirmwareUpdateConfig()
        }
      },
      navToHome () {
        this.$router.push('/accountsadmin_home')
      },
      navToList () {
        this.$router.push('/accountsadmin_list')
      },
    },
  }
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }

  .container .center .nav-bar span{
    cursor: pointer;
  }

  .container .center .content {
    margin-top:40px;
    padding-left: 8%;
    font-size:14px;
  }

  .container .center .content .text {
    margin:10px 0;
  }

  .container .center .content .check {
    margin-top:10px;
  }

  .container .center .content .check input {
    float: left;
  }
  .container .center .content .check span {
    float: left;
    margin-left:10px;
  }

  .container .center .content .email input{
    height:24px;
    width:300px;
    font-size:16px;
  }

  .container .center .content input[type="checkbox"] {
    /*width:18px;*/
    /*height:18px;*/

    width: 18px;
    height: 18px;
    /*background-color: #fff;*/
    /*-webkit-appearance:none;*/
    border: 1px solid #c9c9c9;
    border-radius: 2px;
    outline: none;
  }

  .container .center .content input[type="checkbox"]:checked {
    /*background: url("/static/accountadmin/icon_selected.png") no-repeat center;*/
  }

  .container .center .no-data {
    padding-top: 5%;
  }

  .container .center .no-data .text {
    text-align: center;
    font-size:20px;
    *margin-top: 20%;
  }

  .container .center .add-btn {
    width:150px;
    background-color:#0c544f;
    height:30px;
    border-radius:20px;
    /*margin: 0 auto;*/
    margin-top:30px;
    cursor: pointer;
  }

  .container .center .add-btn {
    color: #fff;
    text-align: center;
    line-height: 30px;
  }



</style>



// WEBPACK FOOTER //
// AccountAdminAdd.vue?3be8cf52